(function () {
  'use strict';

  var LS_KEY = 'cart_recently_viewed';
  var LS_KEY_LEGACY = 'ig_rv_tropeaka';
  var MAX_STORED = 3;
  var MAX_DISPLAYED = 3;

  function getStoredProducts() {
    try {
      return JSON.parse(localStorage.getItem(LS_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveStoredProducts(products) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(products));
    } catch (e) {}
  }

  function migrateLegacyStorage() {
    try {
      var legacy = localStorage.getItem(LS_KEY_LEGACY);
      if (!legacy) return;
      if (!localStorage.getItem(LS_KEY)) {
        localStorage.setItem(LS_KEY, legacy);
      }
      localStorage.removeItem(LS_KEY_LEGACY);
    } catch (e) {}
  }

  function trackPDPVisit() {
    var dataEl = document.getElementById('cart-recently-viewed-product-data');
    if (!dataEl) return;

    var item;
    try {
      item = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    if (!item || !item.id) return;

    var stored = getStoredProducts();
    stored = stored.filter(function (p) { return p.id !== item.id; });
    stored.unshift(item);
    saveStoredProducts(stored.slice(0, MAX_STORED));
  }

  function formatPrice(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.rvMoneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Fallback for entries stored before imageUrl was available
  function legacyImageUrl(image) {
    if (!image) return '';
    var raw = typeof image === 'string' ? image : (image.src || '');
    if (!raw) return '';
    var url = raw.startsWith('//') ? 'https:' + raw : raw;
    return url + (url.includes('?') ? '&' : '?') + 'width=200';
  }

  function buildCard(p) {
    var tpl = document.getElementById('cart-recently-viewed-item-tpl');
    var card = tpl.content.cloneNode(true).firstElementChild;

    var imgSrc = p.imageUrl || legacyImageUrl(p.image);
    var imgLink = card.querySelector('.cart-recently-viewed__item-img-link');
    imgLink.href = p.url;

    var img = card.querySelector('.cart-recently-viewed__item-img');
    if (imgSrc) {
      img.src = imgSrc;
    } else {
      img.classList.add('cart-recently-viewed__item-img--placeholder');
    }

    var infoLink = card.querySelector('.cart-recently-viewed__item-info');
    infoLink.href = p.url;

    var starsRow = card.querySelector('.cart-recently-viewed__item-stars-row');
    if (p.reviewCount) {
      card.querySelector('.cart-recently-viewed__item-review-count').textContent = p.reviewCount;
    } else {
      starsRow.remove();
    }

    card.querySelector('.cart-recently-viewed__item-name').textContent = p.title;

    var variantEl = card.querySelector('.cart-recently-viewed__item-variant');
    if (p.variantTitle) {
      variantEl.textContent = p.variantTitle;
    } else {
      variantEl.remove();
    }

    card.querySelector('.cart-recently-viewed__item-price').textContent = formatPrice(p.price) + ' AUD';

    var btn = card.querySelector('[data-cart-recently-viewed-atc]');
    btn.dataset.variantId = p.variantId;
    btn.textContent = p.variantAvailable ? 'ADD TO BAG' : 'SOLD OUT';
    if (!p.variantAvailable) btn.disabled = true;

    return card;
  }

  function buildSection(products) {
    var tpl = document.getElementById('cart-recently-viewed-tpl');
    var section = tpl.content.cloneNode(true).firstElementChild;
    var list = section.querySelector('.cart-recently-viewed__list');
    products.forEach(function (p) { list.appendChild(buildCard(p)); });
    return section;
  }

  function bindATCButtons(container) {
    container.querySelectorAll('[data-cart-recently-viewed-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId || btn.disabled) return;
        handleAddToCart(variantId, btn);
      });
    });
  }

  function removeFromStorage(variantId) {
    var stored = getStoredProducts();
    saveStoredProducts(stored.filter(function (p) { return p.variantId !== variantId; }));
  }

  async function handleAddToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'ADDING...';
    document.dispatchEvent(new Event('onCartPending'));

    try {
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!resp.ok) throw new Error('Add to cart failed');

      removeFromStorage(variantId);
      btn.textContent = 'ADDED!';
      document.dispatchEvent(new Event('onCartFinished'));
    } catch (e) {
      btn.textContent = 'ADD TO BAG';
      btn.disabled = false;
      document.dispatchEvent(new Event('onCartFinished'));
    }
  }

  async function renderSection() {
    var contents = document.querySelector('[data-cart-drawer-contents]');
    if (!contents) return;

    var cartItems = [];
    try {
      var cartResp = await fetch('/cart.js');
      var cart = await cartResp.json();
      cartItems = cart.items || [];
    } catch (e) {}

    var existing = contents.querySelector('[data-cart-recently-viewed]');
    if (existing) existing.remove();

    if (cartItems.length === 0) return;

    var cartProductIds = cartItems.map(function (item) { return item.product_id; });

    var stored = getStoredProducts();
    var clean = stored.filter(function (p) { return !cartProductIds.includes(p.id); });
    if (clean.length !== stored.length) saveStoredProducts(clean);

    var toShow = clean.slice(0, MAX_DISPLAYED);
    if (toShow.length === 0) return;

    var section = buildSection(toShow);

    var inner = contents.querySelector('[data-cart-drawer-contents-inner]');
    if (inner) {
      inner.after(section);
    } else {
      contents.appendChild(section);
    }

    bindATCButtons(section);
  }

  var renderDebounceTimer = null;
  function debouncedRender(delay) {
    clearTimeout(renderDebounceTimer);
    renderDebounceTimer = setTimeout(renderSection, delay || 150);
  }

  function setupObservers() {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) return;

    var inner = cartDrawer.querySelector('[data-cart-drawer-contents-inner]');
    if (inner) {
      new MutationObserver(function () {
        debouncedRender(150);
      }).observe(inner, { childList: true });
    }

    new MutationObserver(function () {
      debouncedRender(150);
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });

    document.addEventListener('onCartFinished', function () {
      debouncedRender(300);
    });
  }

  function init() {
    migrateLegacyStorage();
    trackPDPVisit();
    if (!document.querySelector('[data-cart-drawer]')) return;
    setupObservers();
    renderSection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
